import {Component, EventEmitter, Input, Output} from '@angular/core';
import {Campus} from '../../model/Campus';
import {Helper} from '../../model/Helper';

export interface UploadAssetBundlePayload {
  campus: Campus;
  platform: string;
  assetBundle: File;
}

export interface RemoveAssetBundlePayload {
  campus: Campus;
  platform: string;
}

@Component({
  selector: 'app-edit-campus-assetbundles',
  templateUrl: 'edit-campus-assetbundles.component.html',
  styleUrls: ['edit-campus-assetbundles.component.css'],
})
export class EditCampusAssetbundlesComponent {
  @Input() public campus: Campus;

  @Output() public uploadAssetBundle = new EventEmitter<UploadAssetBundlePayload>();
  @Output() public removeAssetBundle = new EventEmitter<RemoveAssetBundlePayload>();

  public Helper = Helper;

  public uploadAssetBundleClicked(platform: string): void {
    const fileButton = document.getElementById('assetBundleFile') as HTMLInputElement;
    this.uploadAssetBundle.emit({
      campus: this.campus,
      platform: platform,
      assetBundle: fileButton.files[0],
    });
  }

  public removeAssetBundleClicked(platform: string): void {
    this.removeAssetBundle.emit({
      campus: this.campus,
      platform: platform,
    });
  }
}
